import semver from 'semver'

export async function fetchVersionsFromNpm (pkg, range) {
  const res = await fetch(`https://registry.npmjs.org/${pkg}`, {
    headers: {
      Accept: 'application/vnd.npm.install-v1+json',
    },
  })

  if (!res.ok) {
    throw new Error(`Failed to fetch versions for ${pkg}`)
  }

  const json = await res.json()

  return {
    tags: json['dist-tags'],
    versions: Object.keys(json.versions)
      .filter(version => semver.satisfies(version, range, { includePrerelease: true }))
      .sort((a, b) => semver.rcompare(a, b)),
  }
}
